import React, { useState } from "react";
import { Button } from "antd";

import './../css/widget/widget.button.css';


// 新增按钮
const AddButton = ({text = '新增', htmlType = '', icon = 'frame/add_btn', onClick = () => {}, style = {}}) => {
    return (
        <span className="sf-button">
            <Button type="primary" htmlType={htmlType} onClick={onClick} icon={icon && <img src={require(`./../img/${icon}.png`)} />} style={{ display: icon && 'flex', alignItems: icon && 'center', ...style }}>{text}</Button>
        </span>
    )
}

// 常规按钮
const GeneralButton = ({text = '删除', icon = 'frame/del_btn', onClick = () => {}, style = {}}) => {
    const [isHover, setIsHover] = useState(false);
    return (
        <span className="sf-button">
            <Button type="general" onClick={onClick}  onMouseEnter={()=>{setIsHover(!isHover)}} onMouseLeave={()=>{setIsHover(false)}} icon={icon && <img src={require(`./../img/${icon}${isHover ? '1' : ''}.svg`)} />} style={{ display: icon && 'flex', alignItems: icon && 'center', ...style }}>{text}</Button> 
        </span>
    )
}

//订单
const OrderButton = ({text = '订单评价', htmlType = '', icon = 'frame/order', onClick = () => {}, style = {}}) => {
    return (
        <span className="sf-button">
            <Button type="primary" htmlType={htmlType} onClick={onClick} icon={icon && <img src={require(`./../img/${icon}.png`)} />} style={{ display: icon && 'flex', alignItems: icon && 'center', ...style }}>{text}</Button>
        </span>
    )
}
// 接单
const TakeButton = ({text = '确认', htmlType = '', icon = 'frame/Take', onClick = () => {}, style = {}}) => {
    return (
        <span className="sf-button">
            <Button type="primary" htmlType={htmlType} onClick={onClick} icon={icon && <img src={require(`./../img/${icon}.png`)} />} style={{ display: icon && 'flex', alignItems: icon && 'center', ...style }}>{text}</Button>
        </span>
    )
}

// 忽略
const LoseButton = ({text = '忽略', htmlType = '', icon = 'frame/add_btn', onClick = () => {}, style = {}}) => {
    return (
        <span className="sf-button">
            <Button type="general" htmlType={htmlType} onClick={onClick} icon={icon && <img src={require(`./../img/frame/lose.png`)} />} style={{ display: icon && 'flex', alignItems: icon && 'center', ...style }}>{text}</Button>
        </span>
    )
}


//导入 导出
const ExportButton = ({text = '导出', icon = 'frame/export_btn', type='', onClick = () => {}, style = {}}) => {
    const [isHover, setIsHover] = useState(false);
    return (
        <span className="sf-button">
            <Button type={type?type:'general'} onClick={onClick}  onMouseEnter={()=>{setIsHover(!isHover)}} onMouseLeave={()=>{setIsHover(false)}} icon={icon && <img src={require(`./../img/${icon}.png`)} />} style={{ display: icon && 'flex', alignItems: icon && 'center', ...style }}>{text}</Button> 
        </span>
    )
}
// 导出
const ExportLIneButton = ({text = '导出', icon = 'frame/export_03', type='', onClick = () => {}, style = {}}) => {
    const [isHover, setIsHover] = useState(false);
    return (
        <span className="sf-button">
            <Button type={type?type:'general'} onClick={onClick}  onMouseEnter={()=>{setIsHover(!isHover)}} onMouseLeave={()=>{setIsHover(false)}} icon={ <img src={require(`./../img/frame/export_03.png`)} />} style={{ display: icon && 'flex', alignItems: icon && 'center', ...style }}>{text}</Button> 
        </span>
    )
}


//打印
const PrintButton = ({text = '打印', icon = 'frame/print', onClick = () => {}, style = {}}) => {
    const [isHover, setIsHover] = useState(false);
    return (
        <span className="sf-button">
            <Button type="general" onClick={onClick}  onMouseEnter={()=>{setIsHover(!isHover)}} onMouseLeave={()=>{setIsHover(false)}} icon={icon && <img src={require(`./../img/${icon}.png`)} />} style={{ display: icon && 'flex', alignItems: icon && 'center', ...style }}>{text}</Button> 
        </span>
    )
}


const ImportButton = ({text = '导出', icon = 'frame/export_btn', onClick = () => {}, style = {}}) => {
    const [isHover, setIsHover] = useState(false);
    return (
        <span className="sf-button">
            <Button type="general" onClick={onClick}  onMouseEnter={()=>{setIsHover(!isHover)}} onMouseLeave={()=>{setIsHover(false)}} icon={icon && <img src={require(`./../img/${icon}.png`)} />} style={{ display: icon && 'flex', alignItems: icon && 'center', ...style }}>{text}</Button> 
        </span>
    )
}

// 线型按钮新增
const AddLineButton = ({text = '新增', htmlType = '', icon = 'frame/add_btn_line', onClick = () => {}, style = {}}) => {
    return (
        <span className="sf-button">
            <Button type="primary" htmlType={htmlType} ghost onClick={onClick} icon={icon && <img src={require(`./../img/${icon}.png`)} />} style={{ display: icon && 'flex', alignItems: icon && 'center', ...style }}>{text}</Button>
        </span>
    )
}


// 线型按钮常规
const  GeneralLineButton = ({text = '删除', icon = 'frame/del_btn_line', onClick = () => {}, style = {}}) => {
    return (
        <span className="sf-button">
            <Button type="general" ghost onClick={onClick} icon={icon && <img src={require(`./../img/${icon}.png`)} />} style={{ display: icon && 'flex', alignItems: icon && 'center', ...style }}>{text}</Button>
        </span>
    )
}

export {
    AddButton,
    GeneralButton,
    AddLineButton,
    GeneralLineButton,
    ExportButton,
    ImportButton,
    PrintButton,
    ExportLIneButton,
    LoseButton,
    TakeButton,
    OrderButton,
}

